import React from 'react';
import './Home.scss';
import Scene from '../../components/Scene';

const Home = () => (

  <div className="home" >
    <Scene />
  </div>
  
);

export default Home;